import * as Scrivito from "scrivito";

Scrivito.provideComponent("BoxWidget", ({ widget }) => {
  const classNames = ["box-widget"];
  classNames.push(`bg-${widget.get("boxStyle") || "transparent"}`);

  return (
    <Scrivito.WidgetTag className={classNames.join(" ")}>
      <Scrivito.ContentTag content={widget} attribute="body" />
    </Scrivito.WidgetTag>
  );
});
